import { render } from "./categoryImageTeaser.vue?vue&type=template&id=6b6c786e"
import script from "./categoryImageTeaser.vue?vue&type=script&lang=js"
export * from "./categoryImageTeaser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__